<template>
  <el-row class="core_four_wrap">
    <el-col class="four_left">
      <div class="left_tit">
        {{ core.subTitle }}
      </div>
      <div class="left_desc" v-html="core.desc"></div>
      <el-row class="four_items">
        <el-col class="four_item" v-for="item in core.children">
          <div class="item_title">{{ item.title }}</div>
          <div class="item_content">{{ item.content }}</div>
        </el-col>
      </el-row>
    </el-col>
    <el-col class="four_right">
      <img :src="core.image" alt="">
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    core: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.core_four_wrap {
  display: flex;
  justify-content: center;
  text-align: left;

  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
  }

  .four_left {
    width: 40%;

    @media screen and (max-width: 768px) {
      width: 90%;
    }

    .left_tit {
      color: #3e3e3e;
      font-size: 20px;
      font-weight: bold;

      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        margin-top: 20PX;
      }
    }

    .left_desc {
      color: #717171;
      padding: 10px 40px 20px 40px;
      line-height: 25px;

      @media screen and (max-width: 768px) {
        font-size: 14px;
      }
    }

    .four_items {
      display: flex;
      flex-wrap: wrap;
      padding-left: 40px;

      .four_item {
        width: 45%;
        margin-bottom: 20px;
        background: #f8f8f8;
        border-radius: 8px;
        padding: 15px;
        margin-right: 10px;

        @media screen and (max-width: 768px) {
          width: 100%;
          margin-right: 0;
          margin-bottom: 15px;
        }

        .item_title {
          color: #04cac7;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
        }

        .item_content {
          color: #717171;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }

  .four_right {
    width: 30%;
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 768px) {
      width: 100%;
      margin-top: 20PX;
    }

    img {
      width: 80%;
      margin-top: 40px;
    }
  }
}
</style>
